import { EMOJI_BY_CODE_MAP, MESSAGE_EMOJI_SRC } from "../constants/components/emoji";

export function encodeHtmlChars(text) {
    const div = document.createElement('div');
    div.innerText = text;

    return div.innerHTML;
}

export function encodeInnerHTML(childNodes, regexp='emoji_u([^\.]+)\.png') {
    let result = '';
    let previousNodeWasBlock = false;

    childNodes.forEach((child) => {
        if (child.nodeType === Node.TEXT_NODE) {
            result += child.textContent;
        } else if (child.nodeName === 'IMG') {
            const codePoints = child.src?.match(regexp)[1].split('_');
            const decimalCodePoints = codePoints?.map((point) => parseInt(point, 16));
            const emojiCharacters = decimalCodePoints?.map((point) => String.fromCodePoint(point));
            result += emojiCharacters?.join('');
            previousNodeWasBlock = false;
        } else if (child.nodeName === 'BR') {
            result += '\n';
            previousNodeWasBlock = false;
        } else if (child.nodeType === Node.ELEMENT_NODE && child.nodeName !== 'IMG') {
            const innerText = encodeInnerHTML(child.childNodes, regexp);

            if (innerText.trim()) {
                if (previousNodeWasBlock) {
                    result += '\n';
                }

                result += innerText;
                previousNodeWasBlock = true;
            }
        }
    })

    return result.trim();
}

function getEmojiCode(emoji) {
    const codePoint = emoji.codePointAt(0).toString(16).toUpperCase();
    return codePoint.padStart(4, '0');
}

export function replaceEmojiToImage(string) {
    const emojiRegex = /(?:[\u00A9\u00AE\u2122]|[\u2600-\u27BF]|[\u2B00-\u2BFF]|[\u203C-\u2049]|[\u231A-\u23FF]|(?:\uD83C[\uDF00-\uDFFF])|(?:\uD83D[\uDE00-\uDEFF])|[\uD800-\uDBFF][\uDC00-\uDFFF]|\u200D)/g;

    const matchingElements = string.match(emojiRegex) || [];

    if (!matchingElements.length) {
        return string;
    }

    const unicodeCodes = matchingElements.reduce((acc, elem) => {
        const codePoint = getEmojiCode(elem).toLowerCase();

        if (codePoint === '200d') {
            acc[acc.length - 1] += ' ';

            return acc;
        }

        if (!!acc.length && acc[acc.length - 1].slice(-1) === ' ') {
            acc[acc.length - 1] += codePoint;
        } else {
            acc.push(codePoint);
        }

        return acc;
    }, []);

    const emojiRegexForReplace = /((\ud83c[\udde6-\uddff]){2}|([\#\*0-9]\u20e3)|(\u00a9|\u00ae|[\u2000-\u3300]|[\ud83c-\ud83e][\ud000-\udfff])((\ud83c[\udffb-\udfff])?(\ud83e[\uddb0-\uddb3])?(\ufe0f?\u200d([\u2000-\u3300]|[\ud83c-\ud83e][\ud000-\udfff])\ufe0f?)?)*)/g

    const innerHtml = string.replace(emojiRegexForReplace, (value) => {
        const codesPoint = unicodeCodes.shift()?.replaceAll(' ', '_200d_');

        if (!EMOJI_BY_CODE_MAP[codesPoint]) {
            return value;
        }

        const imageSrc = MESSAGE_EMOJI_SRC(codesPoint);

        return `<img src="${imageSrc}" />`;
    });

    return innerHtml;
}

function isValidUrl(url) {
    const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
    return urlRegex.test(url);
}

function isSafeUrl(url) {
    const dangerousPatterns = /javascript:|data:|vbscript:|<|>/i;
    const dangerousChars = /["'<>`]/;

    return !dangerousPatterns.test(url) && !dangerousChars.test(url);
}

export function replaceUrlsToLinks(text) {
    const urlPattern = /(https?|ftp):\/\/[^\s/$.?#].[^\s]*/gi;

    return text.replace(urlPattern, (url) => {
        if (isValidUrl(url) && isSafeUrl(url)) {
            return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
        }
        return url;
    });
}
